import {BaseSelectFiller} from "./BaseSelectFiller";
import React from "react";

export const AutocompleteSelectFiller = ({content, setFieldValue}) => <BaseSelectFiller content={content}
                                                                                        setFieldValue={setFieldValue}
/>